import { parseDirectionOverrides, resolveDirectionOverrides } from '@/_pure/directionRule';
import { parsePrimitiveCameraCatalog, PRIMITIVE_CAMERA_CATALOG } from '@/adapters/primitive/_pure/derivation/primitiveCameraRules';
import { parsePrimitiveDirectionCatalog } from '@/adapters/primitive/_pure/derivation/primitiveDirectionRules';
import { parseWorkflowDirectionCatalog, WORKFLOW_DIRECTION_CATALOG, WORKFLOW_ROD_DIRECTION_CATALOG } from '@/workflow-runner/_pure/workflowDirectionRules';
import { WORKFLOW_ROD_MOMENT_VOCABULARY } from '@/workflow-runner/_pure/workflowMoment';
import type { WorkflowSceneDirection, WorkflowSceneDirectionCatalogs } from '@/workflow-runner/_contract/sceneDirection';

export function parseWorkflowSceneDirection(value: unknown): WorkflowSceneDirection | undefined {
    if (value === undefined) return undefined;
    if (!value || typeof value !== 'object' || Array.isArray(value)) throw new Error('Invalid Workflow scene direction.');
    const object = value as Record<string, unknown>;
    for (const key of Object.keys(object)) if (!['replay', 'rodVisuals', 'rodCamera'].includes(key)) throw new Error(`Unknown Workflow direction domain '${key}'.`);
    return {
        ...(object.replay === undefined ? {} : { replay: parseDirectionOverrides(object.replay, WORKFLOW_DIRECTION_CATALOG, parseWorkflowDirectionCatalog) }),
        ...(object.rodVisuals === undefined ? {} : { rodVisuals: parseDirectionOverrides(object.rodVisuals, WORKFLOW_ROD_DIRECTION_CATALOG,
            value => parsePrimitiveDirectionCatalog(value, WORKFLOW_ROD_MOMENT_VOCABULARY)) }),
        ...(object.rodCamera === undefined ? {} : { rodCamera: parseDirectionOverrides(object.rodCamera, PRIMITIVE_CAMERA_CATALOG,
            value => parsePrimitiveCameraCatalog(value, WORKFLOW_ROD_MOMENT_VOCABULARY)) }),
    };
}

export function resolveWorkflowSceneDirection(direction?: WorkflowSceneDirection): WorkflowSceneDirectionCatalogs {
    return {
        replay: resolveDirectionOverrides(WORKFLOW_DIRECTION_CATALOG, direction?.replay),
        rodVisuals: resolveDirectionOverrides(WORKFLOW_ROD_DIRECTION_CATALOG, direction?.rodVisuals),
        rodCamera: resolveDirectionOverrides(PRIMITIVE_CAMERA_CATALOG, direction?.rodCamera),
    };
}
